import { orpc, useInvalidateRpcQueryFn } from 'src/api/rpc/client';
import { IntegrationKey } from '@erp/rpc';
import { useQuery, useMutation } from '@tanstack/react-query';

export function useListIntegrations() {
  return useQuery(orpc.integrations.list.queryOptions());
}

export function useGetIntegration(key: IntegrationKey) {
  return useQuery(orpc.integrations.get.queryOptions({ input: { key } }));
}

export function useUpdateIntegration() {
  const invalidateIntegrationsQueries = useInvalidateRpcQueryFn(
    (orpc, { key }: { key: IntegrationKey }) => [
      orpc.integrations.list.key(),
      orpc.integrations.get.key({ input: { key } }),
    ],
  );
  return useMutation(
    orpc.integrations.update.mutationOptions({
      onSuccess: ({ key }) => {
        invalidateIntegrationsQueries({ key });
      },
    }),
  );
}
